import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet} from 'react-native';

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.23,
  shadowRadius: 2.62,

  elevation: 4,
};

export default (props: ITheme) => {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: props.colors.dirtyWhite,
    },
    flex: {
      flex: 1,
    },
    profileNameContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 16,
      flexDirection: 'row',
      backgroundColor: props.colors.white,
      height: 62,
      marginTop: 44,
      borderRadius: 10,
      ...shadow,
    },
    penContainer: {
      paddingRight: 24,
    },
    penImage: {
      width: 13,
      height: 13,
    },
    buttonStyle: {
      marginTop: Platform.OS === 'android' ? 24 : 0,
    },

    deleteButtonTitleColor: {
      color: props.colors.red,
      ...props.typography.notoSansRegular,
    },
  });
};
